import { Component, Input } from '@angular/core';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-doughnut-chart',
  template: `
    <div style="position: relative;">
      <canvas id="doughnutChart"></canvas>
      <div class="center-text">
        <span class="percentage" style="color: #d091b5;">Female {{ chartPercentageLabels[0] }}%</span>
        <span class="percentage" style="color: #56b3e3;">Male {{ chartPercentageLabels[1] }}%</span>
      </div>
    </div>
  `,
  styleUrls: ['./doughnut-chart.component.scss']
})
export class DoughnutChartComponent {
  @Input() chartData: number[];
  @Input() chartLabels: string[];
  @Input() chartPercentageLabels: string[];

  chart: any;

  ngAfterViewInit() {
    this.chart = new Chart('doughnutChart', {
      type: 'doughnut',
      data: {
        labels: this.chartLabels,
        datasets: [{
          data: this.chartData,
          backgroundColor: ['#d091b5', '#56b3e3']
        }]
      },
      options: {
        legend: {
          display: false // Hide the legend
        },
        cutoutPercentage: 80,
        plugins: {
          datalabels: {
            anchor: 'end',
            align: 'end',
            formatter: (value, context) => {
              return '';
            }
          }
        }
      }
    });
  }
}


// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/dashboard/doughnut-chart/doughnut-chart.component.ts